export const config = {
  PostcodeSearchForm: {
    subtitle: 'Use the postcode finder below to enter the address where you would like our Home Design Service to help.',
    additionalFormDescription: (<p>Your virtual appointment will be with a Stylist nearest to the property.</p>),
  },
};
